import { render, staticRenderFns } from "./wechatBind.vue?vue&type=template&id=38e3122d&scoped=true"
import script from "./wechatBind.vue?vue&type=script&lang=js"
export * from "./wechatBind.vue?vue&type=script&lang=js"
import style0 from "./wechatBind.vue?vue&type=style&index=0&id=38e3122d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e3122d",
  null
  
)

export default component.exports